import NavBar from "../home/components/NavBar";
import Footer from "../home/components/Footer";
import SingleUseSection from "../home/components/SingleUseSection";

export default function SingleUseFormPage() {
  return (
    <main className="min-h-screen bg-[#EFEBE5]">
      <NavBar />
      <div className="pt-16">
        <SingleUseSection />
      </div>
      <Footer />
    </main>
  );
}
